import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { STATUS } from "../../../redux/constants";
import CeroInput from "../../../components/CeroInput";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useNavigate, useParams } from "react-router-dom";
import { getSupplierSurveyQuestions } from "../../../redux/actions/supplierScreening";
import CeroButton from "../../../components/CeroButton";
import { supplierSurveyResponse } from "../../../redux/actions/supplierScreening";
import { useSnackbar } from "notistack";
import { resetSupplierScreeningStatus } from "../../../redux/actions/supplierScreening";
import axios from "axios";
import { styled } from "@mui/material/styles";
import { APIEndpoints } from "../../../redux/constants";
import CeroPhoneInput from "../../../components/CeroPhoneInput";
import CeroAutoComplete from "../../../components/CeroAutoComplete";
import { getCountryList, getStatesPublic } from "../../../redux/actions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const SupplierScreeningResponse = () => {
  const classes = useStyles();
  const [selectedValues, setSelectedValues] = useState({});
  const dispatch = useDispatch();
  const { answerId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [textAnswers, setTextAnswers] = useState({});
  const [state, setState] = useState("");
  const [country, setcountry] = useState("");
  const [companyNumber, setCompanyNumber] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [companyName, setCompanyName] = useState("");

  const [supplierInfoAnswers, setSupplierInfoAnswers] = useState({});
  const [requiredAnswers, setRequiredAnswers] = useState({});

  const [errors, setErrors] = React.useState({});
  const requiredFields = [
    "Company Name",
    "Company Number",
    "Designation",
    "Email",
    "Contact Number",
    "Street",
    "Unit",
    "Country",
    "State",
    "Postal",
    "Contact Name",
  ];

  // const normalizeField = (name) => name?.toLowerCase().replace(/[-_\s]/g, ""); // removes spaces, hyphens, underscores

  const validateInput = (value, fieldName) => {
    let error = "";
    // const normalized = normalizeField(fieldName);
    if (requiredFields.includes(fieldName)) {
      if (!value.trim()) {
        error = `${fieldName} is required.`;
      } else if (
        ["Company Number", "Contact Number"].includes(fieldName) &&
        value.length < 10
      ) {
        error = `${fieldName} is required`;
      } else if (
        (fieldName.toLowerCase().includes("email") ||
          fieldName.toLowerCase().includes("e-mail")) &&
        !/\S+@\S+\.\S+/.test(value)
      ) {
        error = "Invalid email format.";
      } else {
        setRequiredAnswers({ ...requiredAnswers, [fieldName]: value });
      }
    }
    setErrors((prev) => ({ ...prev, [fieldName]: error }));
  };

  const isFormValid = () => {
    return requiredFields.every((field) => {
      const value = requiredAnswers[field];
      const error = errors[field];
      return value && !error;
    });
  };

  const handleBlur = (fieldName, value) => {
    // Trigger validation on blur if the field is required
    validateInput(value, fieldName);
  };

  const supplierQuestionsList = useSelector((state) => {
    const data = state.supplierScreening.getSupplierSurveyQuestions.data;
    return Array.isArray(data) ? data : [];
  });
  const questionListStatus = useSelector(
    (state) => state.supplierScreening.getSupplierSurveyQuestions.status
  );
  const formStatus = useSelector(
    (state) => state.supplierScreening.supplierSurveyResponse
  );

  useEffect(() => {
    if (country && country.id) dispatch(getStatesPublic(country.id));
  }, [country, dispatch]);

  const handleCheckboxChange = (event, questionId) => {
    const value = event.target.value;
    setSelectedValues((prevValues) => {
      const questionValues = prevValues[questionId] || [];
      if (questionValues.includes(value)) {
        return {
          ...prevValues,
          [questionId]: questionValues.filter((item) => item !== value),
        };
      } else {
        return {
          ...prevValues,
          [questionId]: [...questionValues, value],
        };
      }
    });
  };

  const handleFileUpload = async (file, questionId) => {
    const formData = new FormData();
    for (let i = 0; i < file.length; i++) formData.append("file", file[i]);
    try {
      const response = await axios.post(
        APIEndpoints.SURVEY_FILE_UPLOAD(answerId, questionId),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const blobUrl = response.data?.blob_url;
      enqueueSnackbar("File uploaded successfully.", {
        variant: "success",
      });
      if (blobUrl) {
        setTextAnswers((prevAnswers) => {
          const key = `file-${questionId}`;
          const existingValue = prevAnswers[key];

          return {
            ...prevAnswers,
            [key]: Array.isArray(existingValue)
              ? [...existingValue, ...blobUrl] // Append to the existing array
              : existingValue
              ? [existingValue, ...blobUrl] // Convert to array if it's a single value
              : blobUrl, // Set as a single value if no existing value
          };
        });
      }
    } catch (error) {
      enqueueSnackbar("File upload failed. Please try again.", {
        variant: "error",
      });
    }
  };

  const onSubmit = () => {
    const answerList = supplierQuestionsList.map((question) => {
      let answer = "";
      let answer_value = "";
      if (
        question.question_type === "text" ||
        question.question_type === "short_text" ||
        question.question_type === "Text Field"
      ) {
        answer = textAnswers[question.id] || "";
      } else if (
        question.question_type === "choose_from_option" ||
        question.question_type === "Choose from Options"
      ) {
        answer = selectedValues[question.id] || "";

        if (answer === "Other (please specify)") {
          answer_value = textAnswers[`other-${question.id}`] || "";
        }
      } else if (question.question_type === "multiselect_check_box") {
        const selectedOptions = selectedValues[question.id] || [];
        answer = selectedOptions.join(", ");
        if (selectedOptions.includes("Other (please specify)")) {
          answer_value = textAnswers[`other-${question.id}`] || "";
        }
      } else if (question.question_type === "upload") {
        answer = textAnswers[`file-${question.id}`] || "";
      }
      return {
        question_id: question.id,
        answer,
        question_type: question.question_type,
        ...(answer_value && { answer_value }),
      };
    });
    Object.entries(supplierInfoAnswers).forEach(([key, value]) => {
      answerList.push({
        question_id: key,
        answer: value,
        question_type: typeof value === "object" ? "object" : "text",
        answer_value: "",
      });
    });
    const payload = {
      answer_list: answerList,
      company_name: companyName,
    };

    dispatch(supplierSurveyResponse(answerId, payload));
  };

  useEffect(() => {
    if (formStatus.status === STATUS.SUCCESS) {
      navigate("/supplier-assessment/survey-response");
    } else if (formStatus.status === STATUS.ERROR) {
      enqueueSnackbar(
        formStatus.message ||
          "We couldn't process your request. Please try again later.",
        {
          variant: "error",
          autoHideDuration: 3000,
        }
      );
      dispatch(resetSupplierScreeningStatus());
    }
  }, [formStatus, dispatch, enqueueSnackbar]);

  const handleTextInputChange = (questionId, value) => {
    setTextAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: value,
    }));
  };

  const handleSingleSelect = (questionId, selectedOption) => {
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [questionId]: selectedOption,
    }));

    if (selectedOption.toLowerCase().includes("other")) {
      setTextAnswers((prevAnswers) => ({
        ...prevAnswers,
        [`other-${questionId}`]: "",
      }));
    }
  };

  useEffect(() => {
    if (answerId) {
      dispatch(getSupplierSurveyQuestions(answerId));
      dispatch(getCountryList());
    }
  }, [dispatch, answerId]);

  const groupedQuestions = supplierQuestionsList?.reduce((acc, question) => {
    const section = question.section || "Custom";
    if (!acc[section]) {
      acc[section] = [];
    }
    acc[section].push(question);
    return acc;
  }, {});

  function reorderLists(data) {
    Object.keys(data).forEach((key) => {
      const list = data[key];
      const reorderedList = [];
      const itemMap = new Map();

      list.forEach((item) => {
        itemMap.set(item.id, item);
      });

      list.forEach((item) => {
        if (!reorderedList.includes(itemMap.get(item.id))) {
          reorderedList.push(item);
        }

        const relatedItems = list.filter(
          (related) => related.question_id === item.id
        );
        relatedItems.forEach((relatedItem) => {
          if (!reorderedList.includes(relatedItem)) {
            reorderedList.push(relatedItem);
          }
        });
      });

      const remainingItems = list.filter(
        (item) => !reorderedList.includes(item)
      );
      reorderedList.push(...remainingItems);

      data[key] = reorderedList;
    });

    return data;
  }

  const VisuallyHiddenInput = styled("input")({
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0,0,0,0)",
    border: 0,
  });

  let questionNumber = 3;

  const countryListData = useSelector(
    (state) => state.listings.countryList.data
  );
  const countryList = countryListData.map((item) => ({
    id: item.code,
    label: item.name,
    value: item.code,
  }));
  const stateList = useSelector((state) => state.listings.getStates.data);

  const stateNames = country
    ? Object.values(stateList).map((stateObj) => Object.values(stateObj)[0])
    : [];

  const renderSupplierInfo = (infoQuestions) => {
    delete groupedQuestions["Company Profile"];
    var qtIndex = 1;
    const nameCont = infoQuestions?.filter((item) =>
      ["company name", "company phone number", "contact name"].includes(
        item.question.toLowerCase()
      )
    );

    const addrCntct = infoQuestions?.filter((item) =>
      ["address"].includes(item.question.toLowerCase())
    );

    const order = [
      // "contact",
      "designation",
      "email",
      "contact number",
      // "address",
    ];

    const others = infoQuestions
      ?.filter((item) => order.includes(item.question.toLowerCase()))
      .sort((a, b) => {
        return (
          order.indexOf(a.question.toLowerCase()) -
          order.indexOf(b.question.toLowerCase())
        );
      });
    const question = infoQuestions?.filter(
      (item) => item.question_type === "choose_from_option"
    )[0];
    if (question.is_mandatory) {
      requiredFields.push(question.id);
    }

    return (
      <>
        <Typography
          fontSize={18}
          fontWeight={600}
          variant="body1"
          paddingTop={2}
          marginTop={1}
          className={classes.mainQuestion}
        >
          {"Company Profile"}
        </Typography>
        <Typography
          fontSize={18}
          fontWeight={500}
          variant="body1"
          className={classes.mainQuestion}
        >
          {`1. Supplier information:`}
        </Typography>
        <Box className={classes.supInfo}>
          {nameCont?.map((it, index) => (
            <Grid
              key={it.id}
              paddingLeft={6}
              className={classes.supInfoQuaterContent}
            >
              <Typography className={classes.subQuestion}>
                {`${String.fromCharCode(96 + qtIndex + index)}. ${it.question}`}
              </Typography>
              <Box>
                {it.question.toLowerCase().includes("phone") ? (
                  <CeroPhoneInput
                    required
                    // sx={{ width: "250px" }}
                    // label="Company Number"
                    name="company phone"
                    value={companyNumber}
                    onChange={(value) => {
                      setCompanyNumber(value);
                      setSupplierInfoAnswers({
                        ...supplierInfoAnswers,
                        [it.id]: value,
                      });
                    }}
                    error={Boolean(errors["Company Number"])}
                    helperText={errors["Company Number"]}
                    onBlur={(event) =>
                      handleBlur("Company Number", event.target.value)
                    }
                    classes={{ container: classes.phoneInput }}
                  />
                ) : (
                  <CeroInput
                    classes={{
                      container: classes.textAreaContainerShort,
                      input: classes.textAreaContainerInput,
                    }}
                    rows={2}
                    placeholder={"Please type your Answer"}
                    id={`answer-${it.id}-${it.question}`}
                    name={`answer-${it.id}-${it.question}`}
                    // label={`Enter ${it.question}`}
                    multiline
                    onChange={(event) => {
                      setSupplierInfoAnswers({
                        ...supplierInfoAnswers,
                        [it.id]: event.target.value,
                      });
                      const questionLower = it.question.toLowerCase();

                      if (questionLower.includes("company name")) {
                        setCompanyName(event.target.value);
                      } else if (questionLower.includes("designation")) {
                        setSupplierInfoAnswers({
                          ...supplierInfoAnswers,
                          [it.id]: event.target.value,
                        });
                      } else if (questionLower.includes("email")) {
                        // optional email validation logic here if needed
                      } else if (questionLower.includes("contact")) {
                        setContactNumber(event.target.value); // if you're storing contact separately
                      }
                    }}
                    error={Boolean(errors[it.question])}
                    helperText={errors[it.question]}
                    onBlur={(event) =>
                      handleBlur(it.question, event.target.value)
                    }
                  />
                )}
              </Box>
            </Grid>
          ))}
          {addrCntct?.map((it, index) => (
            <Grid
              key={it.id}
              paddingLeft={6}
              className={classes.supInfoFullContent}
            >
              <Typography className={classes.subQuestion}>
                {`${String.fromCharCode(
                  96 +
                    (nameCont?.length ? nameCont?.length : 0) +
                    qtIndex +
                    index
                )}. ${it.question}`}
              </Typography>
              <Box className={classes.addressInner}>
                <CeroInput
                  classes={{
                    container: classes.inputContainerFreeMargin,
                  }}
                  rows={2}
                  placeholder={"street address"}
                  id={`answer-${it.id}-${it.question}-street`}
                  name={`answer-${it.id}-${it.question}-street`}
                  // label={`Enter street address`}
                  multiline
                  onChange={(event) => {
                    setSupplierInfoAnswers({
                      ...supplierInfoAnswers,
                      [it.id]: {
                        ...supplierInfoAnswers[it.id],
                        street: event.target.value,
                      },
                    });
                  }}
                  error={Boolean(errors["Street"])}
                  helperText={errors["Street"]}
                  onBlur={(event) => handleBlur("Street", event.target.value)}
                />
                <CeroInput
                  classes={{
                    container: classes.inputContainerFreeMargin,
                  }}
                  rows={2}
                  placeholder={"unit number"}
                  id={`answer-${it.id}-${it.question}-unit`}
                  name={`answer-${it.id}-${it.question}-unit`}
                  // label={`Enter Unit Number`}
                  multiline
                  onChange={(event) => {
                    setSupplierInfoAnswers({
                      ...supplierInfoAnswers,
                      [it.id]: {
                        ...supplierInfoAnswers[it.id],
                        unit: event.target.value,
                      },
                    });
                  }}
                  error={Boolean(errors["Unit"])}
                  helperText={errors["Unit"]}
                  onBlur={(event) => handleBlur("Unit", event.target.value)}
                />

                <CeroAutoComplete
                  required
                  id="country"
                  name="country"
                  label="Country"
                  fullWidth
                  options={countryList}
                  value={country}
                  onChange={(e, value) => {
                    setcountry(value);
                    setState("");
                    setSupplierInfoAnswers({
                      ...supplierInfoAnswers,
                      [it.id]: {
                        ...supplierInfoAnswers[it.id],
                        country: value?.id,
                      },
                    });
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value
                  }
                  disabled={false}
                  placeholder={"contry"}
                  error={Boolean(errors["Country"])}
                  helperText={errors["Country"]}
                  onBlur={(event) => handleBlur("Country", event.target.value)}
                />

                <CeroAutoComplete
                  required
                  id="State"
                  name="State"
                  label={stateNames.length === 0 ? "State/Province/Region" : ""}
                  fullWidth
                  options={stateNames.map((state) => ({
                    label: state,
                    value: state,
                  }))}
                  value={state}
                  onChange={(e, value) => {
                    setState(value);
                    setSupplierInfoAnswers({
                      ...supplierInfoAnswers,
                      [it.id]: {
                        ...supplierInfoAnswers[it.id],
                        state: value?.value || null,
                      },
                    });
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value
                  }
                  disabled={stateNames.length === 0}
                  error={Boolean(errors["State"])}
                  helperText={errors["State"]}
                  onBlur={(event) => handleBlur("State", event.target.value)}
                  placeholder={"State"}
                />

                <CeroInput
                  classes={{
                    container: classes.inputContainerFreeMargin,
                  }}
                  rows={2}
                  placeholder={"postal"}
                  id={`answer-${it.id}-${it.question}`}
                  name={`answer-${it.id}-${it.question}`}
                  // label={`Enter postal`}
                  multiline
                  onChange={(event) => {
                    setSupplierInfoAnswers({
                      ...supplierInfoAnswers,
                      [it.id]: {
                        ...supplierInfoAnswers[it.id],
                        postal: event.target.value,
                      },
                    });
                  }}
                  error={Boolean(errors["Postal"])}
                  helperText={errors["Postal"]}
                  onBlur={(event) => handleBlur("Postal", event.target.value)}
                />
              </Box>
            </Grid>
          ))}
          {others?.map((it, index) => (
            <Grid
              key={it.id}
              paddingLeft={6}
              className={classes.supInfoQuaterContent}
            >
              <Typography className={classes.subQuestion}>
                {`${String.fromCharCode(
                  96 +
                    (nameCont?.length ? nameCont?.length : 0) +
                    (addrCntct?.length ? addrCntct?.length : 0) +
                    qtIndex +
                    index
                )}. ${it.question}`}
              </Typography>
              <Box>
                {it.question.toLowerCase().includes("number") ? (
                  <CeroPhoneInput
                    required
                    // sx={{ width: "250px" }}
                    // label="Contact Number"
                    name="phone"
                    value={contactNumber}
                    onChange={(value) => {
                      setContactNumber(value);
                      setSupplierInfoAnswers({
                        ...supplierInfoAnswers,
                        [it.id]: value,
                      });
                    }}
                    classes={{ container: classes.phoneInput }}
                    error={Boolean(errors["Contact Number"])}
                    helperText={errors["Contact Number"]}
                    onBlur={(event) =>
                      handleBlur("Contact Number", event.target.value)
                    }
                  />
                ) : (
                  <CeroInput
                    classes={{
                      container: it.question.toLowerCase().includes("address")
                        ? classes.bigTextInputContainer
                        : classes.textAreaContainerShort,
                      input: it.question.toLowerCase().includes("address")
                        ? undefined
                        : classes.textAreaContainerInput,
                    }}
                    rows={2}
                    placeholder={"Please type your Answers"}
                    id={`answer-${it.id}-${it.question}`}
                    name={`answer-${it.id}-${it.question}`}
                    // label={`Enter ${it.question}`}
                    multiline
                    onChange={(event) => {
                      const value = event.target.value;

                      setSupplierInfoAnswers({
                        ...supplierInfoAnswers,
                        [it.id]: value,
                      });

                      // ✅ Live email validation
                      if (
                        it.question.toLowerCase().includes("email") ||
                        it.question.toLowerCase().includes("e-mail")
                      ) {
                        validateInput(value, it.question);
                      }
                    }}
                    error={Boolean(errors[it.question])}
                    helperText={
                      errors[it.question] ||
                      it.question.toLowerCase().includes("email") ||
                      it.question.toLowerCase().includes("e-mail")
                    }
                    onBlur={(event) =>
                      handleBlur(it.question, event.target.value)
                    }
                  />
                )}
              </Box>
            </Grid>
          ))}
        </Box>
        <Box key={question?.id} style={{ margin: "5px 0px" }}>
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <Typography className={classes.mainQuestion}>
              {`2. ${question?.question}`}
            </Typography>
            {question.is_mandatory && (
              <Typography className={classes.starMark}>{`*`}</Typography>
            )}
          </div>
          <Box paddingLeft={6}>
            {question?.options?.map((option, idx) => (
              <React.Fragment key={idx}>
                <FormControlLabel
                  control={
                    <Checkbox
                      className={classes.selectCheckbox}
                      checked={selectedValues[question.id] === option}
                      onChange={() => {
                        handleSingleSelect(question.id, option);
                        if (question.is_mandatory) {
                          requiredFields.push(question.id);
                          setRequiredAnswers({
                            ...requiredAnswers,
                            [question.id]: true,
                          });
                        }
                      }}
                      value={option}
                      sx={{
                        color: "#5A404E !important",
                        "&.Mui-checked": {
                          color: "#8C2148 !important",
                        },
                      }}
                    />
                  }
                  label={option}
                  className={classes.textAreaContainerInput1}
                />

                {(selectedValues[question.id] === "Other (please specify)" ||
                  selectedValues[question.id] === "Other (please specify):") &&
                  option === "Other (please specify):" && (
                    <Box ml={4} mt={1}>
                      {" "}
                      {/* Same spacing as multiselect "Other" */}
                      <TextField
                        variant="outlined"
                        placeholder="Please type your Answer"
                        multiline
                        sx={{ width: "50%" }}
                        rows={3}
                        value={textAnswers[`other-${question.id}`] || ""}
                        onChange={(e) =>
                          handleTextInputChange(
                            `other-${question.id}`,
                            e.target.value
                          )
                        }
                        className={classes.textAreaContainerInput1}
                      />
                    </Box>
                  )}
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </>
    );
  };

  return (
    <Paper className={classes.container}>
      <Box mb={4} display="flex" justifyContent="space-between" paddingY={2}>
        <Typography fontSize={20} fontWeight={550} variant="h3">
          SUPPLIER ASSESSMENT INDUSTRY SPECIFIC QUESTIONNAIRE
        </Typography>
      </Box>
      {questionListStatus === STATUS.SUCCESS ? (
        <>
          {renderSupplierInfo(groupedQuestions["Company Profile"])}
          {Object.entries(reorderLists(groupedQuestions))?.map(
            ([sectionTitle, questions]) => (
              <Box key={sectionTitle} mb={4}>
                <Typography
                  fontSize={18}
                  fontWeight={600}
                  variant="body1"
                  paddingTop={2}
                  marginTop={1}
                  className={classes.mainQuestion}
                >
                  {sectionTitle}
                </Typography>
                {questions?.map((question) => {
                  if (question.question_id === null) {
                    const currentQuestionNumber = questionNumber;
                    questionNumber += 1;
                    if (question.is_mandatory) {
                      requiredFields.push(question.id);
                    }
                    return (
                      <Grid
                        key={question.id}
                        className={
                          question.question_type === "text"
                            ? classes.inputGrid
                            : classes.gridItem
                        }
                      >
                        <div style={{ display: "flex" }}>
                          <Typography
                            fontSize={18}
                            fontWeight={500}
                            variant="body1"
                            className={classes.mainQuestion}
                          >
                            {`${currentQuestionNumber}. ${question.question}`}
                          </Typography>
                          {question.is_mandatory && (
                            <Typography
                              fontSize={18}
                              fontWeight={500}
                              variant="body1"
                              className={classes.starMark}
                            >
                              {"*"}
                            </Typography>
                          )}
                        </div>
                        <Box
                          display="flex"
                          flexDirection="column"
                          paddingLeft={6}
                          className={
                            question.question_type === "text"
                              ? classes.textDiv
                              : classes.layout
                          }
                        >
                          {question.question_type === "multiselect_check_box" &&
                            question.options.map((option, idx) => {
                              return (
                                <>
                                  <FormControlLabel
                                    key={idx}
                                    control={
                                      <Checkbox
                                        className={classes.selectCheckbox}
                                        checked={
                                          selectedValues[question.id]?.includes(
                                            option
                                          ) || false
                                        }
                                        onChange={(e) => {
                                          handleCheckboxChange(e, question.id);
                                          if (question.is_mandatory)
                                            setRequiredAnswers({
                                              ...requiredAnswers,
                                              [question.id]: e.target.value,
                                            });
                                        }}
                                        value={option}
                                        sx={{
                                          color: "#5A404E !important",
                                          "&.Mui-checked": {
                                            color: "#8C2148 !important",
                                          },
                                        }}
                                      />
                                    }
                                    label={option}
                                    className={classes.label}
                                  />
                                  {selectedValues[question.id]?.some((opt) =>
                                    opt.toLowerCase().includes("other")
                                  ) &&
                                    option.toLowerCase().includes("other") && (
                                      <CeroInput
                                        classes={{
                                          container:
                                            classes.textAreaContainerInput1,
                                        }}
                                        variant="outlined"
                                        placeholder="Please type your Answer"
                                        multiline
                                        sx={{ width: "50% !important" }}
                                        rows={2}
                                        value={
                                          textAnswers[`other-${question.id}`] ||
                                          ""
                                        }
                                        onChange={(e) =>
                                          handleTextInputChange(
                                            `other-${question.id}`,
                                            e.target.value
                                          )
                                        }
                                        className={
                                          classes.textAreaContainerInput1
                                        }
                                      />
                                    )}
                                </>
                              );
                            })}

                          {(question.question_type === "choose_from_option" ||
                            question.question_type === "Choose from Options") &&
                            question.options.map((option, idx) => {
                              return (
                                <>
                                  <FormControlLabel
                                    key={idx}
                                    control={
                                      <Checkbox
                                        className={classes.selectCheckbox}
                                        checked={
                                          selectedValues[question.id] === option
                                        }
                                        onChange={() => {
                                          handleSingleSelect(
                                            question.id,
                                            option
                                          );
                                          if (question.is_mandatory)
                                            setRequiredAnswers({
                                              ...requiredAnswers,
                                              [question.id]: option,
                                            });
                                        }}
                                        value={option}
                                        sx={{
                                          color: "#5A404E !important",
                                          borderWidth: "none",
                                          "&.Mui-checked": {
                                            color: "#8C2148 !important",
                                          },
                                        }}
                                      />
                                    }
                                    label={option}
                                  />
                                  {selectedValues[question.id]
                                    ?.toLowerCase()
                                    .includes("other") &&
                                    option.toLowerCase().includes("other") && (
                                      <TextField
                                        variant="outlined"
                                        placeholder="Please type your Answer"
                                        multiline
                                        rows={3}
                                        value={
                                          textAnswers[`other-${question.id}`] ||
                                          ""
                                        }
                                        onChange={(e) =>
                                          handleTextInputChange(
                                            `other-${question.id}`,
                                            e.target.value
                                          )
                                        }
                                        className={
                                          classes.textAreaContainerInput1
                                        }
                                      />
                                    )}
                                </>
                              );
                            })}
                          {question.question_type === "upload" && (
                            <Box className={classes.upload}>
                              <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                className={classes.buttonPrimary}
                                startIcon={<CloudUploadIcon />}
                              >
                                Upload files
                                <VisuallyHiddenInput
                                  type="file"
                                  onChange={(e) => {
                                    if (e.target.files.length) {
                                      handleFileUpload(
                                        e.target.files,
                                        question.id
                                      );
                                      if (question.is_mandatory)
                                        setRequiredAnswers({
                                          ...requiredAnswers,
                                          [question.id]: true,
                                        });
                                    }
                                  }}
                                  multiple
                                />
                              </Button>

                              {/* Show file preview & delete below */}
                              <Box mt={2}>
                                {(Array.isArray(
                                  textAnswers[`file-${question.id}`]
                                )
                                  ? textAnswers[`file-${question.id}`]
                                  : textAnswers[`file-${question.id}`]
                                  ? [textAnswers[`file-${question.id}`]]
                                  : []
                                ).map((url, index) => (
                                  <Box
                                    key={index}
                                    display="flex"
                                    alignItems="center"
                                    gap={2}
                                    mb={1}
                                  >
                                    <Typography variant="body2">
                                      File {index + 1}
                                    </Typography>

                                    <IconButton
                                      variant="outlined"
                                      sx={{ color: "#8C2148" }}
                                      onClick={() => {
                                        const currentFiles = Array.isArray(
                                          textAnswers[`file-${question.id}`]
                                        )
                                          ? textAnswers[`file-${question.id}`]
                                          : [
                                              textAnswers[
                                                `file-${question.id}`
                                              ],
                                            ];

                                        const updatedFiles =
                                          currentFiles.filter(
                                            (_, i) => i !== index
                                          );

                                        setTextAnswers((prevAnswers) => ({
                                          ...prevAnswers,
                                          [`file-${question.id}`]:
                                            updatedFiles.length === 1
                                              ? updatedFiles[0]
                                              : updatedFiles,
                                        }));
                                      }}
                                    >
                                      <DeleteOutlineIcon />
                                    </IconButton>
                                  </Box>
                                ))}
                              </Box>
                            </Box>
                          )}

                          {question.question_type === "text" && (
                            <Box
                              sx={{
                                width: "48%",
                                paddingRight: "16px",
                                marginBottom: "24px",
                              }}
                            >
                              {/* <Typography
                                fontSize={18}
                                fontWeight={500}
                                variant="h3"
                                paddingBottom={1}
                              >
                                {`${currentQuestionNumber}. ${question.question}`}
                              </Typography> */}
                              <CeroInput
                                classes={{
                                  container: classes.textAreaContainerShort,
                                  input: classes.textAreaContainerInput,
                                }}
                                rows={3}
                                placeholder="Please type your Answer"
                                id={`answer-${question.id}`}
                                name={`answer-${question.id}`}
                                label="Please type your Answer"
                                multiline
                                fullWidth
                                value={textAnswers[question.id] || ""}
                                onChange={(e) => {
                                  handleTextInputChange(
                                    question.id,
                                    e.target.value
                                  );
                                  if (question.is_mandatory)
                                    setRequiredAnswers({
                                      ...requiredAnswers,
                                      [question.id]: true,
                                    });
                                }}
                              />
                            </Box>
                          )}
                        </Box>
                      </Grid>
                    );
                  }
                  const subQuestionLetter = String.fromCharCode(
                    96 +
                      supplierQuestionsList
                        .filter((q) => q.question_id === question.question_id)
                        .indexOf(question) +
                      1
                  );
                  return (
                    <Grid key={question.id} paddingLeft={6}>
                      {((question.question.toLowerCase().includes("if yes") &&
                        selectedValues[question.question_id]?.toLowerCase() ===
                          "yes") ||
                        !question.question
                          .toLowerCase()
                          .includes("if yes")) && (
                        <span className={classes.subtopicTitle}>
                          <Typography className={classes.subQuestion}>
                            {`${subQuestionLetter}. ${question.question}`}
                          </Typography>
                          {question.description && (
                            <Tooltip
                              title={question.description}
                              classes={{ popper: classes.tooltip }}
                              arrow
                              placement="right-start"
                            >
                              <InfoOutlinedIcon className={classes.infoIcon} />
                            </Tooltip>
                          )}
                        </span>
                      )}
                      {(question.question_type === "choose_from_option" ||
                        question.question_type === "Choose from Options") &&
                        ((question.question.toLowerCase().includes("if yes") &&
                          selectedValues[
                            question.question_id
                          ]?.toLowerCase() === "yes") ||
                          !question.question
                            .toLowerCase()
                            .includes("if yes")) &&
                        question.options.map((option, idx) => {
                          return (
                            <>
                              <FormControlLabel
                                key={idx}
                                control={
                                  <Checkbox
                                    className={classes.selectCheckbox}
                                    checked={
                                      selectedValues[question.id] === option
                                    }
                                    onChange={() =>
                                      handleSingleSelect(question.id, option)
                                    }
                                    value={option}
                                    sx={{
                                      color: "#5A404E !important",
                                      borderWidth: "none",
                                      "&.Mui-checked": {
                                        color: "#8C2148 !important",
                                      },
                                    }}
                                  />
                                }
                                label={option}
                              />
                              {selectedValues[question.id]
                                ?.toLowerCase()
                                .includes("other") &&
                                option.toLowerCase().includes("other") && (
                                  <TextField
                                    variant="outlined"
                                    placeholder="Please type your Answer"
                                    multiline
                                    rows={3}
                                    value={
                                      textAnswers[`other-${question.id}`] || ""
                                    }
                                    onChange={(e) =>
                                      handleTextInputChange(
                                        `other-${question.id}`,
                                        e.target.value
                                      )
                                    }
                                    className={classes.textAreaContainerInput1}
                                  />
                                )}
                            </>
                          );
                        })}
                      {question.question_type === "multiselect_check_box" &&
                        ((question.question.toLowerCase().includes("if yes") &&
                          selectedValues[
                            question.question_id
                          ]?.toLowerCase() === "yes") ||
                          !question.question
                            .toLowerCase()
                            .includes("if yes")) &&
                        question.options.map((option, idx) => {
                          return (
                            <>
                              <FormControlLabel
                                key={idx}
                                control={
                                  <Checkbox
                                    className={classes.selectCheckbox}
                                    checked={
                                      selectedValues[question.id]?.includes(
                                        option
                                      ) || false
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(e, question.id)
                                    }
                                    value={option}
                                    sx={{
                                      color: "#5A404E !important",
                                      "&.Mui-checked": {
                                        color: "#8C2148 !important",
                                      },
                                    }}
                                  />
                                }
                                label={option}
                                className={classes.label}
                              />
                              {selectedValues[question.id]?.some((opt) =>
                                opt.toLowerCase().includes("other")
                              ) &&
                                option.toLowerCase().includes("other") && (
                                  <CeroInput
                                    classes={{
                                      container: `${classes.textAreaContainerInput1} ${classes.halfWidth}`,
                                    }}
                                    variant="outlined"
                                    placeholder="Please type your Answer"
                                    multiline
                                    rows={3}
                                    sx={{ width: "50%" }}
                                    value={
                                      textAnswers[`other-${question.id}`] || ""
                                    }
                                    onChange={(e) =>
                                      handleTextInputChange(
                                        `other-${question.id}`,
                                        e.target.value
                                      )
                                    }
                                    className={classes.textAreaContainerInput1}
                                  />
                                )}
                            </>
                          );
                        })}
                      {(question.question_type === "text" ||
                        question.question_type === "short_text") &&
                        ((question.question.toLowerCase().includes("if yes") &&
                          selectedValues[
                            question.question_id
                          ]?.toLowerCase() === "yes") ||
                          !question.question
                            .toLowerCase()
                            .includes("if yes")) && (
                          <Box
                            sx={{
                              width: "48%",
                              paddingRight: "16px",
                              marginBottom: "24px",
                            }}
                          >
                            <CeroInput
                              classes={{
                                container: classes.textAreaContainerShort,
                                input: classes.textAreaContainerInput,
                              }}
                              rows={3}
                              placeholder="Please type your Answer"
                              id={`answer-${question.id}`}
                              name={`answer-${question.id}`}
                              label="Please type your Answer"
                              multiline
                              fullWidth
                              value={textAnswers[question.id] || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                handleTextInputChange(question.id, value);

                                // ✅ live validation for email/e-mail
                                if (
                                  question.question
                                    .toLowerCase()
                                    .includes("email") ||
                                  question.question
                                    .toLowerCase()
                                    .includes("e-mail")
                                ) {
                                  validateInput(value, question.question);
                                }
                              }}
                              error={Boolean(errors[question.question])}
                              helperText={
                                errors[question.question] ||
                                question.question
                                  .toLowerCase()
                                  .includes("email") ||
                                question.question
                                  .toLowerCase()
                                  .includes("e-mail")
                              }
                              onBlur={(e) =>
                                handleBlur(question.question, e.target.value)
                              }
                            />
                          </Box>
                        )}

                      {question.question_type === "upload" &&
                        ((question.question.toLowerCase().includes("if yes") &&
                          selectedValues[
                            question.question_id
                          ]?.toLowerCase() === "yes") ||
                          !question.question
                            .toLowerCase()
                            .includes("if yes")) && (
                          <Box className={classes.upload}>
                            <Button
                              component="label"
                              role={undefined}
                              variant="contained"
                              tabIndex={-1}
                              className={classes.buttonPrimary}
                              startIcon={<CloudUploadIcon />}
                            >
                              Upload files
                              <VisuallyHiddenInput
                                type="file"
                                onChange={(e) => {
                                  if (e.target.files.length) {
                                    handleFileUpload(
                                      e.target.files,
                                      question.id
                                    );
                                  }
                                }}
                                multiple
                              />
                            </Button>

                            {/* Show file preview & delete below */}
                            <Box mt={2}>
                              {(Array.isArray(
                                textAnswers[`file-${question.id}`]
                              )
                                ? textAnswers[`file-${question.id}`]
                                : textAnswers[`file-${question.id}`]
                                ? [textAnswers[`file-${question.id}`]]
                                : []
                              ).map((url, index) => (
                                <Box
                                  key={index}
                                  display="flex"
                                  alignItems="center"
                                  gap={2}
                                  mb={1}
                                >
                                  <Typography variant="body2">
                                    File {index + 1}
                                  </Typography>

                                  <IconButton
                                    sx={{ color: "#8C2148" }}
                                    onClick={() => {
                                      const currentFiles = Array.isArray(
                                        textAnswers[`file-${question.id}`]
                                      )
                                        ? textAnswers[`file-${question.id}`]
                                        : [textAnswers[`file-${question.id}`]];

                                      const updatedFiles = currentFiles.filter(
                                        (_, i) => i !== index
                                      );

                                      setTextAnswers((prevAnswers) => ({
                                        ...prevAnswers,
                                        [`file-${question.id}`]:
                                          updatedFiles.length === 1
                                            ? updatedFiles[0]
                                            : updatedFiles,
                                      }));
                                    }}
                                  >
                                    <DeleteOutlineIcon />
                                  </IconButton>
                                </Box>
                              ))}
                            </Box>
                          </Box>
                        )}
                    </Grid>
                  );
                })}
              </Box>
            )
          )}
          <div className={classes.buttonSubmitContainer}>
            <CeroButton
              buttonText="Submit Survey"
              className={classes.buttonPrimary}
              onClick={onSubmit}
              disabled={!isFormValid()}
            />
          </div>
        </>
      ) : (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      )}
    </Paper>
  );
};

export default SupplierScreeningResponse;
